<template>
  <div class="row-onlinebook">
    <!-- <LeftListSupplier  /> -->
    <LeftListSupplier :pos="4"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1 ul-onlinebook">
          <li class="li on">
            <router-link to="/suppliercenter-onlinebook" class="txt">新建目录</router-link>
          </li>
          <li class="li">
            <router-link to="/suppliercenter-bookmanagement" class="txt">目录管理</router-link>
          </li>
<!--          <li class="li">-->
<!--            <router-link to="/suppliercenter-submittedorder" class="txt">订单管理</router-link>-->
<!--          </li>-->
        </ul>
        <div class="contect">
          <div class="m-onlinebook">
            <div class="tit">新建目录</div>
            <form onsubmit="return false">
              <div class="m-frombook">
                <div class="item">
                  <div class="tit1">目录名称：</div>
                  <div class="inp">
                    <div class="tit2">请输入新建目录名称 </div><input type="text" v-model="title" placeholder="点此输入">
                  </div>
                </div>
                <div class="item">
                  <div class="tit1">客户ID绑定：</div>
                  <div class="inp">
                    <div class="tit2">请输入对应客户ID</div><input type="text" v-model="showId" placeholder="点此输入">
                  </div>
                </div>
                <div class="m-btne1">
                  <button type="reset" class="btn1" @click="reset">重置</button>
                  <button type="submit" class="btn1 btn2" @click="submit">确定提交</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import {getApiRes, sleep} from "@/api/apiUtil";
import apiBkBookChoose from "@/api/bkBookChoose";
export default {
  components: {
    LeftListSupplier,
  },
  data() {
    return {
      showId: '',
      title: '',
    };
  },
  mounted() {

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }
  },
  methods: {
    async submit(){
      // if(!this.showId || !this.title) return this.$message.error('请将信息填写完整')
      let re = await getApiRes(apiBkBookChoose.save(this.showId, this.title),0,1,1,1)
      if(re.code==0) {
        this.reset()
        await sleep(1000)
        this.$router.push("/suppliercenter-bookmanagement")
      }
    },
    reset(){
      this.showId = ''
      this.title = ''
    }
  }
};
</script>

<style lang="scss" scoped>
.row-onlinebook {
  overflow: hidden;
  background-color: #F8F8F8;
}

.g-rowe1 {
  float: right;
  width: 1475px;
  min-height: 992px;
  background: #FFFFFF;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.02);
  border-radius: 20px 20px 20px 20px;
  margin: 30px 49px 36px 0;
  padding: 49px 58px 30px;
  overflow: hidden;
}

.m-onlinebook .tit {
  font-size: 18px;
  color: #333333;
  margin-bottom: 44px;

}

.m-onlinebook .inp {
  width: 436px;
  height: 48px;
  line-height: 48px;
  background: #FFFFFF;
  border-radius: 3px;
  border: 1px solid #CBD2D8;
  overflow: hidden;
  padding: 0 19px;
  display: flex;
  align-items: center;

}

.m-frombook .tit1 {
  width: 86px;
  font-size: 14px;
  color: #333333;
}

.m-frombook .tit2 {
  width: 150px;
  font-size: 14px;
  color: #999999;
}

.m-frombook .item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}



.m-frombook input::placeholder,
.m-frombook input {
  width: 100%;
  font-size: 14px;
  color: #333333;
  flex: 1;
}

.m-btne1 {
  overflow: hidden;
  padding-top: 12px;
  padding-left: 86px;
}

.m-btne1 .btn1 {
  float: left;
  font-size: 16px;
  color: #000000;
  width: 110px;
  height: 40px;
  background: #EDF3F9;
  border-radius: 3px;
  border: 1px solid #CBD2D8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 18px;
}

.m-btne1 .btn2 {
  background: #1690FF;
  color: #fff;
  border: 1px solid #1690FF;
}

.m-table .ant-table-thead>tr>th {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /* 设置滚动条宽度 */
}

::v-deep ::-webkit-scrollbar {
  display: initial;

}

::v-deep ::-webkit-scrollbar-track {
  background-color: transparent;
  /* 设置背景颜色 */
}

::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* 设置拖动手柄的边角半径 */
  background-color: #fff;
  /* 设置拖动手柄的背景颜色 */
}

::v-deep ::-webkit-scrollbar-thumb:hover {
  background-color: #fff;
  /* 当鼠标悬停时，设置拖动手柄的背景颜色 */
}

.m-table .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.m-table .top .tit {
  font-size: 18px;
  color: #333333;
}

.m-table .top .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333333;
  width: 90px;
  height: 34px;
  background: #EDF3F9;
  border-radius: 3px;
  border: 1px solid #CBD2D8;
}

.m-table .radio {
  width: 16px;
}

.m-table td:first-child {
  width: auto;
}
</style>
